export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0D1B2A] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/481dad7d-79fb-4494-a936-587c106954e4.png" 
                alt="Climatizzatori 24h Logo" 
                className="w-12 h-12 object-contain"
              />
              <span className="text-white font-bold text-lg">Climatizzatori 24h</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Servizio climatizzatori 24h a Ravenna e dintorni
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#00A3E0] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#00A3E0] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#00A3E0] transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Servizi</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Installazione
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Riparazione
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Manutenzione
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Assistenza 24h
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-fill text-[#00A3E0] mt-1"></i>
                <a href="tel:+393806328251" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  +39 380 632 8251
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-fill text-[#00A3E0] mt-1"></i>
                <a href="mailto:robertoanton@gmail.com" className="text-gray-400 hover:text-white transition-colors cursor-pointer break-all">
                  robertoanton@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-fill text-[#00A3E0] mt-1"></i>
                <span className="text-gray-400">
                  Via Faentina<br />
                  48123 Ravenna, Italia
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Orari</h4>
            <div className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-5 py-3 rounded-full font-bold text-sm mb-4">
              <i className="ri-time-line text-lg"></i>
              EMERGENZE 24/7
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Disponibili 24 ore su 24, 7 giorni su 7 per interventi urgenti e emergenze
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © 2025 Climatizzatori 24h Ravenna e Dintorni. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}